// Keep campaign labels, never arbitrary URL parameters, account data or search text.
export const ATTRIBUTION_KEY = 'sonikly.campaign.v1';
export const INTERNAL_KEY = 'sonikly.analytics.internal';
const fields = ['source', 'medium', 'campaign', 'content'];
const slug = /^[a-zA-Z0-9_-]{1,64}$/;
const ttl = 30 * 60 * 1000;
const landing = new URLSearchParams(window.location.search);
const entry = Object.fromEntries(fields.map((k) => [k, landing.get(`utm_${k}`)]).filter(([, v]) => slug.test(v || '')));
export function internalTraffic() {
  try {
    if (landing.get('analytics_test') === '1') localStorage.setItem(INTERNAL_KEY, '1');
    return localStorage.getItem(INTERNAL_KEY) === '1';
  } catch { return landing.get('analytics_test') === '1'; }
}
export function clearAttribution() {
  lastPage = undefined;
  try {
    const saved = JSON.parse(localStorage.getItem(ATTRIBUTION_KEY) || 'null');
    if (saved?.session_id) fetch('/api/marketing/withdraw', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', keepalive: true, body: JSON.stringify({ session_id: saved.session_id }) })?.catch(() => {});
  } catch { /* withdrawal remains local when offline */ }
  try { localStorage.removeItem(ATTRIBUTION_KEY); } catch { /* storage unavailable */ }
}
export function campaignContext() {
  if (internalTraffic() || window.location.pathname === '/reset-password') return null;
  try {
    let saved = JSON.parse(localStorage.getItem(ATTRIBUTION_KEY) || 'null');
    if (!saved || !Number.isFinite(saved.expires) || typeof saved.session_id !== 'string' || saved.expires < Date.now()) saved = { session_id: crypto.randomUUID(), ...entry };
    // A newly tagged navigation starts a new attribution session; ordinary SPA routes retain it.
    if (entry.source && fields.some((k) => (saved[k] || '') !== (entry[k] || ''))) saved = { session_id: crypto.randomUUID(), ...entry };
    saved = { session_id: saved.session_id, ...Object.fromEntries(fields.filter((k) => slug.test(saved[k] || '')).map((k) => [k, saved[k]])), expires: Date.now() + ttl };
    localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(saved));
    return Object.fromEntries(['session_id', ...fields].filter((k) => saved[k]).map((k) => [k, saved[k]]));
  } catch { return null; }
}
export function gaCampaign(context = campaignContext()) {
  return Object.fromEntries(fields.filter((k) => context?.[k]).map((k) => [`campaign_${k === 'campaign' ? 'name' : k}`, context[k]]));
}
const clientEvents = new Set(['page_view', 'cta_click', 'generation_started', 'generation_succeeded', 'generation_failed', 'audio_play', 'download_gate', 'file_download', 'explorer_opened',
  // Session flows (utils/sessionFlows.js): how a visit moves through the site; the server keeps these 30 days.
  'flow_start', 'ui_click', 'scroll_depth', 'engagement', 'page_visibility', 'page_exit', 'field_focus', 'field_change', 'form_invalid', 'form_submit', 'client_error', 'section_view', 'media_action', 'upload_stage']);
let lastPage;
let flowContext = () => ({});
/** Extra props (tab, view, sequence) added to every event while the session-flow tracker runs; null clears it. */
export function setFlowContext(fn) { flowContext = fn || (() => ({})); }
export function sendFunnelEvent(name, props = {}) {
  if (!clientEvents.has(name)) return;
  if (name === 'page_view' && props.page === lastPage) return;
  const context = campaignContext();
  if (!context) return;
  try {
    if (name === 'page_view') lastPage = props.page;
    const body = JSON.stringify({ ...context, event_id: crypto.randomUUID(), event: name, props: { ...flowContext(), ...props }, analytics_consent: true });
    // No auth header or account cookies are needed by the anonymous event collector.
    const pending = fetch('/api/marketing/events', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, credentials: 'omit', keepalive: true });
    pending?.catch(() => {});
  } catch { /* measurement must never interrupt the product */ }
}
